import { ComponentModalConfig, ModalSize } from 'ngx-fomantic-ui';
import { ICommandModalContext } from './ICommandModalContext';
import { CommandModalComponent } from './command-modal.component';
export class CommandModal extends ComponentModalConfig<ICommandModalContext, void, void> {  
  constructor(options: ICommandModalContext, isfullscreen=false, size = ModalSize.Large) {
    super(CommandModalComponent, options);
    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = isfullscreen;
    (this.size as any) = 'overlay';    
  }
}
